import {
  useMediaQuery,
  colors,
  Grid,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { SectionHeader } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

// Custom styles
const useStyles = makeStyles(theme => ({
  gridContainer: {
    marginTop: theme.spacing(3),
  },
  feedback: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  gridItem: {
    border: 0,
    [theme.breakpoints.up('sm')]: {
      borderRight: `1px solid ${colors.blueGrey[100]}`,
      '&:nth-child(2n)': {
        borderRight: 0,
      },
      '&:nth-child(-n+4)': {
        borderBottom: `1px solid ${colors.blueGrey[100]}`,
      },
    },
    [theme.breakpoints.up('md')]: {
      borderRight: `1px solid ${colors.blueGrey[100]}`,
      '&:nth-child(2n)': {
        borderRight: `1px solid ${colors.blueGrey[100]}`,
      },
      '&:nth-child(-n+4)': {
        borderBottom: 0,
      },
      '&:nth-child(3n)': {
        borderRight: 0,
      },
      '&:nth-child(-n+3)': {
        borderBottom: `1px solid ${colors.blueGrey[100]}`,
      },
    },
  },
}));

export default function Reviews(props) {
  const { className, section, title, subtitle, reviews, refElem, ...rest } = props;

  // Hooks
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        <SectionHeader title={title} subtitle={subtitle} align="center" data-aos="fade-up" />
        <Grid container spacing={isMd ? 4 : 2} className={classes.gridContainer}>
          {reviews.map((review, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index.toString()}
              className={classes.gridItem}
              data-aos="fade-up">
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <ListItem disableGutters key={index.toString()}>
                    {review.author_photo?.url && (
                      <ListItemAvatar>
                        <Avatar
                          src={review.author_photo?.url}
                          alt={review.author_photo?.alt || review.author_name}
                        />
                      </ListItemAvatar>
                    )}
                    <ListItemText
                      primary={review.author_name}
                      secondary={review.author_occupation}
                      primaryTypographyProps={{
                        variant: 'h6',
                        component: 'div',
                      }}
                      secondaryTypographyProps={{
                        variant: 'body1',
                        noWrap: true,
                      }}
                    />
                  </ListItem>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom className={classes.feedback}>
                    {review.feedback}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </div>
    </SectionDynamic>
  );
}

Reviews.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  refElem: PropTypes.any,
  reviews: PropTypes.array.isRequired,
};
